import PolicyContentPage from "../components/PolicyContentPage";

const RefundAndCancellationPolicy = () => (
  <PolicyContentPage
    title="Refund & Cancellation Policy"
    policyType="refundPolicy"
  />
);

export default RefundAndCancellationPolicy;
